export const menu1 = [{
  title: 'Solutions',
  link: '#solutions'
}, {
  title: 'Pricing',
  link: '#pricing'
}, {
  title: 'Docs',
  link: '#docs'
}, {
  title: 'More',
  link: '#more'
}]

export const menu2 = [{
  title: 'Home',
  link: '#section-home'
}, {
  title: 'About',
  link: '#section-about'
}, {
  title: 'Skills',
  link: '#section-skills'
}, {
  title: 'Experience',
  link: '#section-experience'
},{
  title: 'Projects',
  link: '#section-projects'
}]

export default {
  menu1,
  menu2
}
